import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Button, Result } from "antd";
import Loading from "../fragments/Loading";
import { useSession } from "./SessionContext";

const RequireSession: React.FC = () => {
  const { user, loading, loadError, retry, signOut } = useSession();
  const location = useLocation();

  if (loading) {
    return <Loading />;
  }
  if (loadError) {
    return (
      <Result
        status="warning"
        title="Could not reach the server"
        subTitle={`${loadError.message}. You are still signed in; try again in a moment.`}
        extra={[
          <Button key="retry" type="primary" onClick={retry}>
            Try again
          </Button>,
          <Button key="signOut" onClick={signOut}>
            Sign out
          </Button>,
        ]}
      />
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

export default RequireSession;
